import { createContext } from 'react';

// Lets an embedded strategy section publish its action buttons (About / Run Now /
// Generate / Parameters …) up into the shared StrategyCard header row, so the
// controls sit on the header line (right-aligned, after the stats) instead of on
// a separate row inside the body. The value is a setter: setHeaderActions(node).
export const HeaderActionsContext = createContext(() => {});
